import auth0 from 'auth0-js'
import history from './history'
import {
  CLIENT_ID,
  DOMAIN,
  REDIRECT_URI,
  RESPONSE_TYPE,
  SCOPE
} from '../config/constants'

class Authenticate {
  auth0 = new auth0.WebAuth({
    allowedConnections: ['Username-Password-Authentication', 'google-oauth2'],
    clientID: CLIENT_ID,
    domain: DOMAIN,
    redirectUri: REDIRECT_URI,
    responseType: RESPONSE_TYPE,
    scope: SCOPE,
    allowSignUp: false,
    // configurationBaseUrl: 'https://cdn.eu.auth0.com'
  })

  handleAuthentication (loginFulfilled) {
    const href = window.location.href
    const jwt = href.split('#')[1] || null

    // Mapbox url hash interferes with auth0 jwt token
    try {
      const authResult = jwt
        ? JSON.parse(
          '{"' +
              decodeURI(jwt)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
              '"}'
        )
        : null
      if (authResult && authResult.access_token && authResult.id_token) {
        this.setSession(authResult, loginFulfilled)
        history.replace(window.location.pathname)
      }
    } catch(error) {
      if (error.name === 'SyntaxError') {
        // pass 
      } else {
        throw error
      }      
    }
  }

  setSession (authResult, loginFulfilled) {
    // Set the time that the access token will expire at

    const {
      expires_in: expiresIn,
      access_token: accessToken,
      id_token: idToken
    } = authResult

    const expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime())
    loginFulfilled(accessToken, idToken, expiresAt)
    localStorage.setItem('access_token', accessToken)
    localStorage.setItem('id_token', idToken)
    localStorage.setItem('expires_at', expiresAt)
    // navigate to the home route
    history.replace(window.location.pathname)
  }

  login () {
    this.auth0.authorize()
  }

  logout () {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    // navigate to the home route
    // history.replace('/')
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    // const idToken = localStorage.getItem('id_token')
    // const jwt = jwtDecode(idToken)
    // console.log(jwt)
    // console.log(format(expiresAt, 'yyyy-MM-ddTHH:mm:ss.SSSZ'))
    // console.log(new Date().getTime() < expiresAt)
    return new Date().getTime() < expiresAt
  }
}

export const authenticate = new Authenticate()

export default Authenticate
// example url with acces token: http://localhost:3000/#access_token=Hf2SiRK7-k-jcLP7jxCAFSor4T9VV6Zl&id_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJodHRwczovL2F1dGgwLmxvb2tub3J0aHNlcnZpY2VzLmNvbS92MS9wZXJtaXNzaW9ucyI6eyJjb3Jlc2lnaHQyIjp7InJvbGUiOiJ1c2VyIiwicHJvamVjdHMiOnsiaW5mcmFzdHJ1Y3R1cmUiOnsibGF5ZXJzIjp7ImluZnJhc3RydWN0dXJlIjp0cnVlLCJ3ZWxsc2l0ZSI6dHJ1ZSwic2VudGluZWwiOnRydWUsIndhdGVydGVtcGVyYXR1cmUiOnRydWUsIndhdGVyc2VkaW1lbnQiOnRydWUsImxha2UiOnRydWUsIndhdGVybGFrZXRzcyI6dHJ1ZSwid2F0ZXJyaXZlcnNzYyI6dHJ1ZSwid2F0ZXJsYWtlY2hsIjp0cnVlLCJyaXZlcmljZWNodXJjaGlsbCI6dHJ1ZSwibGFuZGRlZm9ybWF0aW9uIjp0cnVlLCJsYW5kX2RlZm9ybWF0aW9uX3ZlYzIiOnRydWUsInJlY2xhaW1lZHdlbGxzaXRlcyI6dHJ1ZX19LCJyZWNsYWltZWR3ZWxsc2l0ZXMiOnsibGF5ZXJzIjp7InJlY2xhaW1lZHdlbGxzaXRlcyI6dHJ1ZSwic2VudGluZWwiOnRydWV9fSwibGFuZGRlZm9ybWF0aW9uIjp7ImxheWVycyI6eyJsYW5kZGVmb3JtYXRpb24iOnRydWUsImxhbmRfZGVmb3JtYXRpb25fdmVjMiI6dHJ1ZSwic2VudGluZWwiOnRydWV9fSwicml2ZXJpY2UiOnsibGF5ZXJzIjp7InJpdmVyaWNlIjp0cnVlLCJzZW50aW5lbCI6dHJ1ZSwicml2ZXJpY2VoaXN0b3JpY2FsIjp0cnVlfX0sIndhdGVydGVtcGVyYXR1cmUiOnsibGF5ZXJzIjp7IndhdGVydGVtcGVyYXR1cmUiOnRydWUsIndhdGVyc2VkaW1lbnQiOnRydWUsImxha2UiOnRydWUsIndhdGVybGFrZXRzcyI6dHJ1ZSwic2VudGluZWwiOnRydWUsIndhdGVycml2ZXJzc2MiOnRydWUsIndhdGVybGFrZWNobCI6dHJ1ZX19fX19LCJuaWNrbmFtZSI6Imd1ZXN0IiwibmFtZSI6Imd1ZXN0QGMtY29yZS5jYSIsImlzcyI6Imh0dHBzOi8vbG9naW4ubG9va25vcnRoc2VydmljZXMuY29tLyIsInN1YiI6ImF1dGgwfDVhOTA2NmZlZGZhZGQ3MGYyOWEzYzUwYyIsImF1ZCI6IlVHMzhucVBFdmE3ZzJNYWpENmVyR0ZNR0phN1RmemN6IiwiaWF0IjoxNTUyNDg2MjAxLCJleHAiOjE1NTg1MzQyMDEsImF0X2hhc2giOiJDUlVjUDR1M3VxalFhY1ZfcC1DTEhnIiwibm9uY2UiOiJkOFNpYkVZTXZ0bHBST0hNZUJ-NHVueFlCYk5td3ZOViJ9.kLgwveIrPQM2mDsu1ORG5wVH38udz7yOvi-u6uGF1wc&scope=openid%20nickname%20name%20https%3A%2F%2Fauth0.looknorthservices.com%2Fv1%2Fpermissions&expires_in=86400&token_type=Bearer&state=5iSdYzUYYH~dIcDEz1RaO6dOBG52j7hA



// WEBPACK FOOTER //
// ./src/api/Authenticate.js